import { Component, Input, output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { AdvancedModel, S25qlSearchAdvancedCriteriaComponent } from "./s25ql.search.advanced.criteria.component";
import { SearchCriteria } from "../../pojo/SearchCriteria";
import { Tokenizer } from "./s25ql.tokenizer";
import { S25qlSearchAdvancedInputTaskComponent } from "./s25ql.search.advanced.input.task.component";
import Searches = SearchCriteria.Searches;

@Component({
    selector: "s25-ng-ql-search-advanced-input",
    template: `
        @if (type !== 10) {
            <s25-ng-ql-search-advanced-criteria
                [type]="type"
                [model]="model"
                [searches]="searches"
                (change)="change.emit()"
            />
        }
        @if (type === 10) {
            <s25-ng-ql-search-advanced-task [(task)]="model.step[0]" (taskChange)="change.emit()" />
        }
    `,
    styles: [``],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [S25qlSearchAdvancedInputTaskComponent, S25qlSearchAdvancedCriteriaComponent],
})
export class S25QLSearchAdvancedInputComponent {
    @Input() type: Tokenizer.QLItemTypes;
    @Input() model: AdvancedModel;
    @Input() searches: Searches;

    readonly change = output<void>();

    @ViewChild(S25qlSearchAdvancedCriteriaComponent) criteriaComponent: S25qlSearchAdvancedCriteriaComponent;
    @ViewChild(S25qlSearchAdvancedInputTaskComponent) taskCriteriaComponent: S25qlSearchAdvancedInputTaskComponent;

    validate() {
        if (this.criteriaComponent) return this.criteriaComponent.validate();
        if (this.taskCriteriaComponent) return this.taskCriteriaComponent.validate();
    }
}
